import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import DisplaySetor from './Componentes/DisplaySetor';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Tooltip } from 'primereact/tooltip';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import { getDataRepository } from '../../../providers/Repository';
import DisplayStatusEquipamento from './Componentes/DisplayStatusEquipamento';
import { RadioButton } from 'primereact/radiobutton';
import SidebarColetas from './Componentes/SidebarColetas';
import TonerLevel from '../../../Componentes/TonerLevel';
import { Badge } from 'primereact/badge';
import SidebarDetalheColetas from './Componentes/SidebarDetalheColetas';
import { Chip } from 'primereact/chip';
import { Menu } from 'primereact/menu';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useNavigate } from 'react-router-dom';  // Importar useNavigate



export default function VisaoDescobertas(props) {
    const toast = React.useRef(null); // Ref para o Toast
    const [ingredient, setIngredient] = useState('parque');
  const navigate = useNavigate();  // Hook para navegação
    const [visible, setVisible] = useState(false);

    const [loading, setLoading] = useState(false);

    const [coletas, setColetas]= useState([]);
    const [selectedColetas, setSelectedColetas]= useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const [usuarios, setUsuarios] = useState([]);

    const [usuario, setUsuario]= useState([]);

    const [visibleLeft, setVisibleLeft] = useState(false);

    const [coleta, setColeta] = useState([]);

    const [verInativos, setVerInativos]= useState(false);

    const [verDesconectados, setVerDesconectados]= useState(false);

    const [verDescobertas, setVerDescobertas]= useState(false);

    const [faixaTonerCiano, setFaixaTonerCiano] = useState([0,100]);

    const [faixaTonerMagenta, setFaixaTonerMagenta] = useState([0,100]);

    const [faixaTonerAmarelo, setFaixaTonerAmarelo] = useState([0,100]);

    const [faixaTonerPreto, setFaixaTonerPreto] = useState([0,100]);

    const [empresa, setEmpresa]= useState([]);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const location = useLocation();

    const { dataEmpresa, disabledItemMenu } = location.state || {};

    const [overlayVisible, setOverlayVisible] = useState(false);

    const op = useRef(null); // Referência para o OverlayPanel

    const requisicaoInicialData = useRef(false); // Referência para o botão de filtro

    const [totalRegistros, setTotalRegistros] = useState(0)
   const [coletasFiltradas, setColetasFiltradas] = useState([])
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
        datacadastro: { value: '', matchMode: FilterMatchMode.EQUALS },
        datacoleta: { value: '', matchMode: FilterMatchMode.EQUALS },
        numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
        modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
        razaosocial: { value: '', matchMode: FilterMatchMode.CONTAINS },
        marca: { value: '', matchMode: FilterMatchMode.CONTAINS },
        ativo: { value: 't', matchMode: FilterMatchMode.EQUALS },
        enderecoip :  { value: '', matchMode: FilterMatchMode.EQUALS },
        equipamentonovo : { value: 't', matchMode: FilterMatchMode.EQUALS },
        
    });

 useEffect(() => {
        if(!requisicaoInicialData.current){
            getData();
            requisicaoInicialData.current = true
        }else{

        }
        
        

    }, []);

const getData = () => {
       
        clearFilters()

       setLoading(true)

         Conexao.post('coletasController/getContadoresData?action=equipamentosnovos', {
            idempresa: dataEmpresa.idempresa,
            idcliente: dataEmpresa.idcliente,
            dias: 0,
        }).then(response => {

            if (response.data.status === 'OK') {

                const temp = response.data.payload;

                for (let i = 0; i < temp.length; i++) {


                    temp[i].dia = 0 ;  

                    temp[i].dias =  false  

                    temp[i].diasCadastro = 0;
                    
                    temp[i].selecionado = 'f';
                
                    temp[i].numeroserieview = temp[i].serialalternativo ? temp[i].serialalternativo : temp[i].numeroserie
                    
                    temp[i].setorview = temp[i].setor ? temp[i].setor : temp[i].syslocation;
                    

                    
                }
             

                setColetas(temp);
                setColetasFiltradas(temp)

            } else {

                setColetas([])
            }
            setTotalRegistros(response.data.payload.length)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
            setColetas([]);

        });
    };

  
    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };


    const handleFilterChange = (e, field) => {

        const value = e.target.value;
        
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: { value, matchMode: FilterMatchMode.CONTAINS },
            
        }));
    };



    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global
        const _filters = { ...filters };
        _filters['global'].value = value;
        
       
        setFilters(_filters);
    
        // Identificar os campos onde o filtro foi encontrado
      
    };
    
    const items = [
        {
            label: 'Opções',
            items: [
                {
                    label: 'Ativar',
                    icon: 'pi pi-check-circle',
                    tooltip : 'Teste',
                    tooltipOptions: { position: 'left' }, 
                    command: () => {
                         if(dataEmpresa.bloqueiofinanceiro === 't'){
                            showMessageToast('error', 'Esta opção esta bloqueada, entre em contato com da Databit!');
                            return
                         }
                         confirmDialog({
                                message: 'Deseja Ativar o monitoramento do equipamento',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                    habilitarListaMonitoramento()
                                }
                            });
                    } 
                    
                },
                {
                    label: 'Remover',
                    icon: 'pi pi-times-circle', 
                    command: () => {
                         if(dataEmpresa.bloqueiofinanceiro === 't'){
                            showMessageToast('error', 'Esta opção esta bloqueada, entre em contato com da Databit!');
                            return
                         }
                         confirmDialog({
                                message: 'Deseja remover o equipamento definitivamente?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                    desativarListaColeta()
                                }
                            });
                    } 
                }
            ]
        }
    ];



    const habilitarListaMonitoramento = () =>{
        const listaColetas	 = selectedColetas.map(function(item){
                                    return item.idcoleta
                                })
            
        Conexao.post('coletasController/habilitarListaMonitoramento?idempresa=', {
             listaColetas	
        }).then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){

                showDialogError('Registro ativado com sucesso!', 'Datacount - Ativação de Coleta', 'success')

                setSelectedColetas([])

                setColetas(prevColetas =>
                    prevColetas.filter(coleta => !listaColetas.includes(coleta.idcoleta))
                );
                
            }else{

                showDialogError('Não foi possível ativar coleta!', 'Datacount - Ativação de Coleta', 'success')

            }
        }).catch(error =>{

            showDialogError('Não foi possivel acessar servido remoto', 'Datacount - Ativação de Coleta', 'warn')

        })
    }

    const desativarListaColeta = () =>{
        const listaColetas	 = selectedColetas.map(function(item){ return item.idcoleta
            })
            
        Conexao.post('coletasController/desativarListaColeta?idempresa=', {
             listaColetas	
        }).then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){
                showDialogError('Registro desabilitado com sucesso!', 'Datacount - Ativação de Coleta', 'success')
                setSelectedColetas([])
                getData()
                
            }else{
                showDialogError('Não foi possível desabilitar coleta!', 'Datacount - Ativação de Coleta', 'success')
            }
        }).catch(error =>{
            showDialogError('Não foi possivel acessar servido remoto', 'Datacount - Ativação de Coleta', 'warn')
        })
    }

    const menuRight = useRef(null);




        const dt = useRef(null);
        const exportarCSV = () => {
            const colunasExportar = ['numeroserie', 'placa', 'marca', 'modelo', 'monototal', 'colortotal', 'contadortotal'];
            const colunasCabecalho = ['numeroSerie', 'Placa', 'Marca', 'Modelo', 'contadorMonoTotal', 'contadorColorTotal', 'contadorTotalGeral'];
    
            let csv = colunasCabecalho.join(';') + '\n';
    
            coletasFiltradas.forEach(item => {
                const linha = colunasExportar.map(col => item[col] ?? ''); // Evita erro se campo for undefined
                csv += linha.join(';') + '\n';
            });
    
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    
            const link = document.createElement("a");
            
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', `relatorioVisaoParque_${new Date().getTime()}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
    
    
        const exportarXLSX = async (reportName = 'dados_export_', coluns) => {
            const colunasExportar = ['numeroserie', 'placa', 'marca', 'modelo', 'numeroserie', 'contadormonototal', 'contadorcolortotal', 'contadortotalgeral']; // Campos que você deseja exportar
            const colunasCabecalho = ['numeroserie', 'placa', 'marca', 'modelo', 'numeroserie', 'contadormonototal', 'contadorcolortotal', 'contadortotalgeral'];
    
            // Gerar os dados filtrados
            const dadosFiltrados = coletasFiltradas.map(item =>
                colunasExportar.reduce((obj, col) => {
                    obj[col] = item[col];
                    return obj;
                }, {})
            );
    
            // Criar worksheet e workbook
            const worksheet = XLSX.utils.json_to_sheet(dadosFiltrados, { header: colunasExportar });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
    
            // Renomear os cabeçalhos no topo (opcional)
            colunasCabecalho.forEach((label, index) => {
                const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
                worksheet[cellAddress].v = label;
            });
    
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    
            // Salvar o arquivo
            const { default: saveAs } = await import('file-saver');
            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            });
            saveAs(blob, 'relatorioVisaoParque_' + new Date().getTime() + '.xlsx');
        };
          
          
          
        const exportarParaPDF = () => {
            const doc = new jsPDF({
                orientation: 'landscape', // 👉 paisagem
                unit: 'pt',
                format: 'a4'
            });
    
            // Cabeçalhos personalizados
            const colunas = [
                { header: 'Numero Série', dataKey: 'numeroserie' },
                { header: 'Patrimônio', dataKey: 'placa' },
                { header: 'Marca', dataKey: 'marca' },
                { header: 'Modelo', dataKey: 'modelo' },
                { header: 'Contador Mono', dataKey: 'monototal' },
                { header: 'Contador Color', dataKey: 'colortotal' },
                { header: 'Contador Total Geral', dataKey: 'contadortotal' },
                { header: 'Scan 1', dataKey: 'scan1' },
                { header: 'Scan 2', dataKey: 'scan2' },
                { header: 'Scan Total', dataKey: 'scantotal' },
            ];
            
            const dataAtual = new Date().toLocaleString('pt-BR');
    
        // Título
            doc.setFontSize(14);
            doc.text('Equipamentos recém descobertos', 40, 40);
            doc.setFontSize(10);
            doc.text(`Data de emissão: ${dataAtual}`, 40, 55);
        
            // Título opcional
            doc.text('datacount collector', 14, 15);
    
            autoTable(doc, {
                headStyles: { fillColor: [26, 35, 126] },
                theme: 'striped',
                columns: colunas,
                body: coletasFiltradas, 
                margin: { top: 60, left: 40, right: 40 },
                startY: 70,
            });
    
            doc.save('relatorioVisaoParque_' + new Date().getTime() + '.pdf');
            
        };

    const renderHeader = () => {

        return (

            <React.Fragment>

            <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '20px', paddingLeft : '0px'}}>
               
                <div className="flex justify-content-row align-items-center gap-2">
                    
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText 
                            value={globalFilterValue} 
                            onChange={onGlobalFilterChange} 
                            disabled = {loading}
                            placeholder="Pesquisa global" 
                            tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                        />
                    </IconField>
                    <Button 
                        icon="pi pi-filter-slash" 
                        className="p-button-secondary p-button-sm" 
                        onClick={clearFilters} 
                        disabled = {loading}
                        tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                    />
                    <Button 
                        icon="pi pi-sync" 
                        className= "p-button-primary p-button-sm" 
                        onClick={getData} 
                        disabled = {loading}
                        tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                    />   
                 
                            
                </div>
                
                <div className="flex flex-column align-items-start p-2" >
                    <Menu 
                         model={items} 
                         disabled={selectedColetas.length === 0  || dataEmpresa.idcliente}
                         popup 
                         ref={menuRight} 
                         id="popup_menu_left" 
                         popupAlignment="left"  
                         style={{marginLeft : '-212px', marginTop:'-100px'}}/>
                    <Button 
                        tooltip='Deseja ativar o monitoramento ou remover o equipamento?' 
                        tooltipOptions={{ position: 'left' }} 
                        disabled={selectedColetas.length === 0}
                        label="Ações" 
                        icon="pi pi-cog" 
                        className="mr-2" 
                        severity='secondary'
                        onClick={(event) => menuRight.current.toggle(event)} 
                        aria-controls="popup_menu_left" 
                        aria-haspopup />
                </div>
            </div>

            </React.Fragment>

        );
    };
    

const renderFooter = () => (
            <div className='flex flex-wrap'>
               <div className='col-12 md:col-10'>
                   <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
                       Total de registros: {coletas.length} 
                   </div>
               </div>
               <div className='col-12 md:col-2 flex-end'>
                   
                   <Button icon="pi pi-file" className='ml-1'  onClick={exportarCSV} tooltip='Baixar dados em CSV' severity="secondary" />  
                   <Button icon="pi pi-file-excel" className='ml-1'  onClick={exportarXLSX}  tooltip='Baixar dados em EXCEL' severity='waning'/> 
                   <Button icon="pi pi-file-pdf" className='ml-1'  onClick={exportarParaPDF}  tooltip='Baixar dados em PDF' severity="danger" />  
                    
               </div>
               
           </div>
);

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
            datacadastro: { value: '', matchMode: FilterMatchMode.EQUALS },
            numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
            modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
            razaosocial: { value: '', matchMode: FilterMatchMode.CONTAINS },
            marca: { value: '', matchMode: FilterMatchMode.CONTAINS },
            datacoleta: { value: '', matchMode: FilterMatchMode.EQUALS },
            ativo: { value: 't', matchMode: FilterMatchMode.EQUALS },
            enderecoip :  { value: '', matchMode: FilterMatchMode.EQUALS },
            equipamentonovo : { value: 't', matchMode: FilterMatchMode.EQUALS },
        });        
        setFieldsFound([]); // Resetando os campos encontrados
    };



  
    
    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedColetas(value);

        // Atualiza o estado do botão "Selecionar Todos"
        const allSelected = coletas.every(c => value.some(s => s.idcoleta === c.idcoleta));
        setSelectAll(allSelected);
    };
    useEffect(()=>{
        console.log(selectedColetas.length)
    },[selectedColetas])

    const onSelectAllChange = (event) => {
        const checked = event.checked;

        if (checked) {
            const newSelected = [
                ...coletas.filter(s => !coletas.some(c => c.idcoleta === s.idcoleta)),
                ...coletas
            ];
            setSelectedColetas(newSelected);
        } else {
            const remaining = selectedColetas.filter(s => !coletas.some(c => c.idcoleta === s.idcoleta));
            setSelectedColetas(remaining);
        }

        setSelectAll(checked);
    };

     const showDialogError = (msg, title, severity) =>{
        


        toast.current.show({ severity: severity, summary: title, detail: msg, life: 3000 });  
    }
    return (
        <Layout loading={loading}>
            <div className="p-2">
              
                <Toast ref={toast} position="bottom-center"  />
                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                
                        <DataTable
                            header={renderHeader()}  
                           
                            value={coletas}
                            paginator 
                             onValueChange={(filteredItems) => {
                                
                                setTotalRegistros(filteredItems.length)
                                setColetasFiltradas(filteredItems)
                            }} 
                            totalRecords={coletas.length}             
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                           paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Registro {first} até {last} de {totalRecords} registro(s)" 
                            tableStyle={{ minWidth: '35rem' }}
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu" // Exibe os filtros como menu pop-up
                            rowClassName={rowData => rowData.ativo === 'f' ? 'row-inativo' : ''}
                            dataKey="idcoleta"
                            selection={selectedColetas}
                            onSelectionChange={onSelectionChange}
                            selectAll={selectAll}
                            onSelectAllChange={onSelectAllChange}
                        >
                            {
                                !dataEmpresa.idcliente ? 
                            
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small, width : '1%' , paddingTop : '2px', paddingBottom : '2px'}} 
                                headerStyle={{ fontSize: fontConfig.small }}                            
                                selectionMode="multiple"
                                /> : null}
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '8%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="enderecoip" 
                                header="Endereço" 
                                body={(row)=>loading ? <Skeleton height="3rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <span>{row.enderecoip}</span>
                                }
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pelo serial" />
                             <Column 
                                    bodyStyle={{ fontSize: fontConfig.small, width : '1%' , paddingTop : '2px', paddingBottom : '2px'}} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    header="DCA" 
                                    field='iddca'                            
                                    body={(row)=>loading ? <Skeleton height="3rem" width="95%" style={{ marginBottom: '10px' , textAlign:'center'}} /> 
                                    : 
                                    <div className='div-dca' 
                                        onClick={()=>{
                                        if(disabledItemMenu) {
                                            
                                            return;
                                        }
                                            navigate('/cadastro-dcas', { state: { ...location.state, isMobile : props.isMobile, disabledItemMenu : disabledItemMenu, filter : {
                                                filtered : true, 
                                                chave : row.chavedca+'-'+row.iddca
                                            } } });
                                        }}>{row.iddca}</div>}
                                    />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '8%', paddingTop : '2px', paddingBottom : '2px' , textAlign:'center' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                header="Descoberta" 
                                field='datacadastro'
                                body={(row)=>loading ? <Skeleton height="3rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                                    <span  style={{fontSize:'10px'}}>{row.datacadastro+' '+row.horacadastro.substr(0,8)}</span><br/>
                                 
                                </div>
                                }
                                sortable 
                                filter 
                                filterPlaceholder="1º Leitura" />
                            
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '8%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="numeroserie" 
                                header="Serial" 
                                body={(row)=>loading ? <Skeleton height="3rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <Tag severity="contrast" style={{cursor:'pointer'}} className='w-full' value={row.numeroserie} ></Tag>
                                }
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pelo serial" />
                             <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '5%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="marca" 
                                header="Marca" 
                                body={(row)=>loading ? <Skeleton height="3rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                                    <span className='text-sm'>{row.marca}</span><br/>
                            
                                </div>
                                }
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pela Marca" />
                                <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '20%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="modelo" 
                                header="Modelo" 
                                body={(row)=>loading ? <Skeleton height="3rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                         
                                    <span className='text-sm'>{row.modelo}</span><br/>
                                </div>
                                }
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pelo modelo" />
                             <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '35%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field='razaosocial' 
                                header="Cliente" 
                                body={(row)=>loading ? <Skeleton height="3rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                                    <span className='text-sm'>{row.razaosocial}</span><br/>
                                    {row.setor ? <DisplaySetor  style={{fontSize:'0.7rem'}}
                                                                            syslocation = {row.setorview}
                                                                            ></DisplaySetor> : null }
                                </div>
                                }
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pelo cliente"
                                />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '6%', paddingTop : '2px', paddingBottom : '2px' , paddingLeft : '1px', paddingRight : '1px'}} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                header="Medidor" 
                                body={(row)=> loading ? <Skeleton height="3rem" width="8%" style={{ marginBottom: '10px' }} /> : 
                                    <div severity="contrast" style={{minWidth : '60px', padding :'3px', border:'solid 1px', textAlign:'center', borderRadius: '5px'}}>
                                        <div>{row.contadortotal}</div>
                                        <div>
                                            <span style={{fontSize:'0.5rem'}}>PB:{row.monototal}</span> 
                                            <span style={{fontSize:'0.5rem', marginLeft : '3px'}}>CL:{row.colortotal}</span>
                                        </div>
                                    </div>
                                 }

                                />
                               
                            {/*<Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                header="Níveis" 
                                body={(row)=>loading ? <Skeleton height="3rem" width="95%" style={{ marginBottom: '10px' }} /> : <>
                               
                                <div className='flex-spacing' >
                                    <TonerLevel 
                                        nivel={row.nivelciano} 
                                        cor='ciano'/>
                                    <TonerLevel 
                                        nivel={row.nivelmagenta} 
                                        cor='magenta'/>
                                    <TonerLevel 
                                        nivel={row.nivelamarelo} 
                                        cor='amarelo'/>
                                    <TonerLevel 
                                        nivel={row.nivelpreto} 
                                        cor='preto'/>                                                                                                                                              
                                </div>
                                </>
                                }

                                />*/}

                           

                          
                        </DataTable>
                    
                </div>                
            </div>

            <OverlayPanel ref={op} style={{ width: '300px' }}>
                    <div className="p-3">
                        <h4>Filtros</h4>
                        <div className="p-field">
                            <label htmlFor="idempresa">Data Cadastro</label>
                            <InputText
                                id="datacadastro"
                                value={filters.datacadastro.value}
                                onChange={(e) => handleFilterChange(e, 'datacadastro')}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="razaosocial">Atualização</label>
                            <InputText
                                id="datacoleta"
                                value={filters.datacoleta.value}
                                onChange={(e) => handleFilterChange(e, 'datacoleta')}
                            />
                        </div>

                        

                        <div className="p-field">
                            <label htmlFor="razaosocial">Serial</label>
                            <InputText
                                id="numeroserie"
                                value={filters.numeroserie.value}
                                onChange={(e) => handleFilterChange(e, 'numeroserie')}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="razaosocial">Marca</label>
                            <InputText
                                id="marca"
                                value={filters.marca.value}
                                onChange={(e) => handleFilterChange(e, 'marca')}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="razaosocial">Modelo</label>
                            <InputText
                                id="modelo"
                                value={filters.modelo.value}
                                onChange={(e) => handleFilterChange(e, 'modelo')}
                            />
                        </div>

                        <Button label="Aplicar Filtro" icon="pi pi-check" onClick={handleFilterConfirm} />
                    </div>
                </OverlayPanel>
             <Toast ref={toast} />
             
        </Layout>
    );
}
